import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, BulletSection, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const Defence = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Defence',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Defence & Aerospace',
                path: '/industries/defence-aerospace',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-gradient-to-t from-[#474747] to-[#292929] shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-24 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.CommondControl ? (
                <img
                  className="h-16 w-16 md:h-12 md:w-12 lg:h-16 lg:w-16 object-contain"
                  src={imagePath?.CommondControl}
                  alt="Commond Control Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Defence"
                desc="Missile Trajectory  Prototyping Simulation"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {videoPath?.DefenceVideo && (
                <video
                  src={videoPath?.DefenceVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Advanced Simulation of Missile Launch Trajectories Across Variable Conditions"
            subtitle="Simulation of testing the missile launch trajectory in different conditions"
            content="There can be various factors that will impact trajectory and efficacy of accomplishing getting
            near the target. The objective of this project is to understand the impact of different conditions
            on the trajectory and launch of the missile. These different conditions needed to be simulated
            and analyzed to improve the efficiency and efficacy of the launch systems."
          />

          <Section
            title="Execution"
            content={[
              'Spatial Grid platform was leveraged to develop the application by using the different plug-ins(like Physics, particle effects, etc.) available. High-speed GPU based processors were used to simulate the different conditions in the application. External controls were interfaced to support the launch simulation. All the interaction data was stored to analyze for generating insights using Machine Learning (ML) methods.',
            ]}
          />
          <BulletSection
            introText="Components developed for this application are as follows:"
            bulletPoints={[
              'VR and MR based experience with scene animations',
              'Interfacing with external hardware-based systems',
              'Particle and Physics effects to simulate different conditions',
              'Interfacing with high-speed processors',
            ]}
            closingText="The project was developed and delivered in 12 weeks."
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.Defence1}
                title="Simulation"
              />
              <CaseStudiesImageCard
                image={imagePath?.Defence2}
                title="Real Time Defence Simulation "
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="This project facilitated the organization to build data sets for optimizing the launch
              trajectory in different conditions. As this was executed leveraging VR and MR technologies the
              organization was able to help save the budget significantly."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;
<BulletSection/>

export default Defence;
